/** Keys for all app-level localStorage entries. */
export enum StorageKey {
  ActiveFirmId = 'activeFirmId',
  SidebarExpanded = 'vt_sidebar_expanded',
  HelpPanelWidth = 'vt_help_panel_width',
  SearchFilter = 'vt_search_filter',
}

// Maps each storage key to its expected string value type.
interface StorageTypeMap {
  [StorageKey.ActiveFirmId]: string;
  [StorageKey.SidebarExpanded]: 'true' | 'false';
  // the help panel's width in px, as a decimal string
  [StorageKey.HelpPanelWidth]: string;
  // the search panel's last-used type filter, an EntityType; absent means "all"
  [StorageKey.SearchFilter]: string;
}

/** Typed wrapper around localStorage keyed by {@link StorageKey}. */
export const AppStorage = {
  /**
   * Retrieves a value from localStorage.
   * @param key - storage key to read
   * @returns the stored string, or null if absent
   */
  get<K extends StorageKey>(key: K): StorageTypeMap[K] | null {
    return localStorage.getItem(key) as StorageTypeMap[K] | null;
  },

  /**
   * Stores a value in localStorage.
   * @param key - storage key to write
   * @param value - string value matching the key's type
   */
  set<K extends StorageKey>(key: K, value: StorageTypeMap[K]): void {
    localStorage.setItem(key, value);
  },

  /**
   * Removes a key from localStorage.
   * @param key - storage key to remove
   */
  remove(key: StorageKey): void {
    localStorage.removeItem(key);
  },
} as const;
